import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _AgreementClassification, _RecordProcess, _RecordType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { FormforGroupSelect } from "../../../bpm/config/Componentes/FormforGroupSelect";
import { SelectorTypeForm } from "../../../bpm/config/Componentes/SelectorTypeForm";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectorProcessTypeConstants } from "../../../bpm/config/Componentes/SelectorProcessTypeConstants";
import { RenderForm } from "../../../theme/Component/RenderForm";
import { RecordTypeSelect } from "../RecordType/RecordTypeSelect";
import { PrintJson } from "../../../theme/Component/PrintJson";






export const RecordProcess = () => {

    const recordprocess = useDataBean(_RecordProcess);
    const [FormInputs, setFormInputs] = useState<any>(null)
    const [idFormType, setIdFormType] = useState<any>(null); // Nuevo estado
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [render, setRender] = useState<any>({ name: 'Render del Formulario', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        recordprocess.instance.getRecordProcessCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        recordprocess.setBean({
            State: 1,
            Since: single.getCurrenDate(),
            IDEmployee: single.getAccountID(),
            YearRecord: single.getCurrenYear(),
            MonthRecord: single.getCurrentMonth(),
            FormInputs: FormInputs,
        });
        setIdFormType(null);
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        recordprocess.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        recordprocess.bean.State = 2;
        //console.log(Project.bean);
        editaItem();

    }




    const head = [
        { title: 'ID', property: 'IDRecordProcess', visible: true },
        { title: 'No. expediente', property: 'NumberRecord', visible: true },
        { title: 'No. externo', property: 'ExternalRecord', visible: true },
        { title: 'Tercero', property: 'IDAccount', visible: true },
        { title: 'Tipo Proceso', property: 'TypeProcess', visible: true },
        // { title: 'Grupo de Formulario', property: 'GroupCode', visible: true },
        { title: 'Usuario Logueado', property: 'IDEmployee', visible: true },
        { title: 'año', property: 'YearRecord', visible: true },
        { title: 'Tipo Expediente', property: 'IDRecordType', visible: true },
        { title: 'Mes', property: 'MonthRecord', visible: true },



    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Formulario', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setRender({ ...render, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Expediente">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={recordprocess.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>




                            <div className="row">
                                <div className="col-md-12">

                                    <AccountEditor label="Tercero" idAccount={recordprocess.bean.IDAccount} onChange={(e) => { recordprocess.setBean({ ...recordprocess.bean, "IDAccount": e.IDAccount }) }} />

                                </div>

                                <div className="col-md-6">
                                    <label>No. expediente</label>
                                    <input type="number" className="form-control" name="NumberRecord" value={recordprocess.bean.NumberRecord} onChange={recordprocess.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>No. externo</label>
                                    <input type="text" className="form-control" name="ExternalRecord" value={recordprocess.bean.ExternalRecord} onChange={recordprocess.handleChange} />

                                </div>

                                <div className="col-md-6">
                                    <SelectorProcessTypeConstants label='Tipo Proceso' idSelector={recordprocess.bean.TypeProcess} onChange={(e: any) => { recordprocess.setBean({ ...recordprocess.bean, "TypeProcess": e }) }} />
                                </div>
                                <div className="col-md-6">

                                    <RecordTypeSelect idSelector={recordprocess.bean.IDRecordType} onChange={(e: any) => { recordprocess.setBean({ ...recordprocess.bean, "IDRecordType": e }); setIdFormType(e.IDFormType) }} />
                                </div>

                            </div>




                        </>
                    </Modal>

                    <Modal modal={render} updateModal={setRender} >
                        <>

                            <RenderForm idFormType={1100} handleUpdate={(data) => setFormInputs(data)} />

                        </>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}